.sparkline-svg {
  display: block;
  width: 100%;
}

.sparkline-container {
  position: relative;
  width: 100%;
}

.sparkline-extrema {
  position: absolute;
  top: 2px;
  right: 8px;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 2px 8px;
  background: color-mix(in srgb, var(--ant-color-bg-elevated) 88%, transparent);
  border: 1px solid var(--ant-color-border-secondary);
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
  pointer-events: none;
  z-index: 1;
}

.sparkline-extrema .extrema-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
